import { render, staticRenderFns } from "./AuthenticationForm.vue?vue&type=template&id=5f1c2f65&scoped=true"
import script from "./AuthenticationForm.vue?vue&type=script&lang=js"
export * from "./AuthenticationForm.vue?vue&type=script&lang=js"
import style0 from "./AuthenticationForm.vue?vue&type=style&index=0&id=5f1c2f65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1c2f65",
  null
  
)

export default component.exports